import { render } from "./categoriesView.vue?vue&type=template&id=8fbd5b40"
import script from "./categoriesView.vue?vue&type=script&lang=js"
export * from "./categoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__